import { markUiObject as __markUi } from '@/i18n/display'
import axios from 'axios'
import { isTokenTimeout } from './auth'
import { notification } from 'ant-design-vue'
import {useRoute} from 'vue-router'
import store from '@/store'
import router from '@/router'
import {assertOrderIdentity,captureOrderIdentity} from './orderContext'
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 20000
})
service.interceptors.request.use(
  (config) => {
    // 2026-09-09：Axios 排队期间切换账号必须停止旧请求；同账号换 token 不改变提交身份。
    const submitted=(config as any).orderSubmissionIdentity
    if(submitted){
      try{assertOrderIdentity(submitted,captureOrderIdentity())}
      catch(error){notification.open(__markUi({message:'下单信息已变化',description:(error as Error).message}, {"message":"下单信息已变化"}));throw error}
    }
    // if(config.headers){
    //     config.headers.icode='978D058300C262E2'
    // }
    // console.log(config.url, 'config')
    if (store.getters.token && config.headers) {
      // if (config.url == 'appointments/uploadImage') {
      //   config.headers['Content-Type'] = 'multipart/form-data'
      // }
      // config.headers.Authorization = `Bearer ${store.getters.token}`
      config.headers.token = store.getters.token
      // config.headers['Content-Type'] = 'application/json; charset=utf-8'
      // if (isTokenTimeout()) {
      //   store.dispatch('user/logout')
      //   notification.open({
      //     message: '登录超时',
      //     description: '登录超时，请重新登录。'
      //   })
      //   return Promise.reject(new Error('TOKEN已过期。'))
      // }
    }else{
      const index=config.url?.indexOf('/')
      if(index){
        const url=config.url?.substring(0,index)
        if(url!=='land'){
          if(store.state.user.loginCallback){
            store.state.user.loginCallback()
          }
        }
      }
      
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
service.interceptors.response.use(
  (response) => {
    // 2026-09-09：旧账号请求完成后不把成功回包交给已切换账号的页面。
    const submitted=(response.config as any).orderSubmissionIdentity
    if(submitted){
      try{assertOrderIdentity(submitted,captureOrderIdentity())}
      catch(error){notification.open(__markUi({message:'下单信息已变化',description:(error as Error).message}, {"message":"下单信息已变化"}));throw error}
    }
    const { success, message, data } = response.data
    if (success) {
      return response.data
    } else {
      
      return Promise.reject(new Error(message))
    }
  },
  (error) => {
    if (
      error.response &&
      error.response.data &&
      // 2026-09-06：环境切换时清理旧登录态，避免把审核或测试身份继续用于另一套数据。
      (error.response.data.code === 40901 || error.response.data.code === 401 || error.response.data.code === 6)
    ) {
      store.dispatch('user/logout')
      const environmentChanged = error.response.data.code === 40901
      notification.open({
        message: environmentChanged ? '服务环境已切换' : '登录超时',
        description: environmentChanged ? '请重新登录后继续操作。' : '登录超时，请重新登录。'
      })
    }
    return Promise.reject(error.response?.data || error)
  }
)
export default service
